/**
 * Whether or not the current window is a deliberate goodxweb child window opened by the main goodxweb window.
 */
export default function isGoodxwebChildWindow(): boolean {
    return window.opener?.origin === window.origin;
}
